export default __webpack_public_path__ + "static/media/no_cure_suggest.b963c51b.png";